/* eslint-disable camelcase */
import { ELKReportName } from '@/types'
import { elkReport } from '@/utils'
import { message } from 'antd'
import { isObject } from 'lodash'

// base
export const currentUrl = window.location.hostname
export const isDev = process.env.NODE_ENV === 'development'
export const isProd = process.env.NODE_ENV === 'production'
export const baseUrl = window.location.hostname
export const loginHost = 'upass.10jqka.com.cn'
export const checkLoginUrl = '//occ-test.10jqka.com.cn/unite-passport/login'

// 错误处理
export const handleError = (error: any) => {
  const { response: res, config, message: messageContent } = error
  const requestInfo = `${config?.method?.toUpperCase?.() || 'UNKNOWN'} ${config?.url || '-'}`
  if (!res) {
    elkReport({
      name: config?.url,
      message: messageContent || requestInfo,
      grade: 'Error',
      category: 'ajax',
      stack: `info: ${ELKReportName.requestError}, no response, request: ${requestInfo}`,
    })
    return
  }
  const stack = `info: ${ELKReportName.requestError}, status: ${res.status}, statusText: ${res.statusText}`
  elkReport({
    name: config.url,
    message: messageContent,
    grade: 'Error',
    category: 'ajax',
    stack,
  })
  // eslint-disable-next-line no-magic-numbers
  if (res.status === 403 || res.status === 400) {
    const { data } = res

    if (!isObject(data)) {
      message.error(data)
      return
    }

    const { status_msg } = data as any

    message.error(status_msg)
    return
  }

  // eslint-disable-next-line no-magic-numbers
  if (res.status === 404) {
    message.error(res.statusText)
    return
  }

  if (res.status === 401) {
    // 没有权限,请登录!
    message.error('No permission, please login!')
    return
  }

  // eslint-disable-next-line no-magic-numbers
  if (res.status >= 500) {
    message.error('Request failed, Please try again later.')
    return
  }
}

// 请求结果插件配置
export const responseConfig = (config: any) => {
  const { error } = config

  if (error) {
    handleError(error)
  }
}

// 数据格式化，后续让useRequest暴露定义
export const dataFormat = (res: any) => {
  if (!res || typeof res !== 'object' || Array.isArray(res)) {
    throw new Error('Unexpected non-JSON response')
  }
  // statusCode、statusMsg是为了兼容不同的接口返回格式
  const { data, status_code, statusCode, status_msg, statusMsg } = res

  if (status_code === 0 || statusCode === 0) {
    return data
  } else {
    message.error(status_msg || statusMsg)
    throw new Error(status_msg)
  }
}
